<template>
    <div class="p-4 flex flex-col gap-4 font-inter">
        <h1 class="text-2xl font-semibold font-quicksand">Mesas</h1>
        <div class="flex items-center gap-4">
            <div class="flex gap-2 items-center">
                <div class="h-4 w-4 bg-red-500"></div>
                Ocupado
            </div>
            <div class="flex gap-2 items-center">
                <div class="h-4 w-4 bg-green-500"></div>
                Livre
            </div>
        </div>
        <div class="grid grid-cols-12 gap-4">
            <button 
                v-for="tableNumber in tableCount" 
                :key="tableNumber" 
                @click="onClickCommand(tableNumber)"
                :class="!(commands[tableNumber] && commands[tableNumber].length > 0) ? 'bg-green-500':'bg-red-500'" 
                class="col-span-4 text-white rounded-xl p-4 transition duration-200"
            >
                <div class="pb-4">
                    <h3 class="font-semibold">Mesa {{ tableNumber }}</h3>
                    <p v-if="commands[tableNumber] && commands[tableNumber].length" class="text-xs">{{ commands[tableNumber].length }} cliente(s)</p>
                    <p v-else class="text-xs">livre</p>
                </div>
            </button>
        </div>

        <!-- Start add customer modal -->
        <MyModal :isOpen="isAddCustomerModalOpen" :toggleModal="(v: boolean) => isAddCustomerModalOpen = v" :zIndex="50">
            <div class="p-4 flex flex-col gap-4">
                <div class="flex justify-between items-center">
                    <button @click="isAddCustomerModalOpen = false" class="transition duration-200 hover:text-primary">
                        <svg viewBox="0 0 24 24" role="presentation" style="width: 1.5rem; height: 1.5rem;"><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" style="fill: currentcolor;"></path></svg>
                    </button>
                    <h3 class="text-xl font-semibold">Cadastro de consumidor</h3>
                </div>
                <div>
                    <button class="bg-zinc-800 text-white font-semibold px-3 py-1 rounded-lg flex items-center gap-2">
                        <svg viewBox="0 0 24 24" role="presentation" style="width: 1.8rem; height: 1.8rem;"><path d="M5,4H19A2,2 0 0,1 21,6V18A2,2 0 0,1 19,20H5A2,2 0 0,1 3,18V6A2,2 0 0,1 5,4M5,8V12H11V8H5M13,8V12H19V8H13M5,14V18H11V14H5M13,14V18H19V14H13Z" style="fill: #fff;"></path></svg>
                        mesa {{ selectedTable }}
                    </button>
                </div>
                <div class="flex flex-col gap-2">
                    <label class="text-md font-medium" for="name">Nome <span class="text-gray-500 text-sm">(opcional)</span></label>
                    <input v-model="commandForm.name" type="text" class="p-4 py-3 border w-full rounded-xl input-primary text-sm md:text-md" placeholder="ex: José Pedro" id="name">
                </div>
                <div class="flex flex-col gap-2">
                    <label class="text-md font-medium" for="description">Descrição <span class="text-gray-500 text-sm">(opcional)</span></label>
                    <textarea v-model="commandForm.description" type="text" class="p-4 py-3 border w-full rounded-xl input-primary text-sm md:text-md" placeholder="ex: Camisa branca, calça preta" id="description"></textarea>
                </div>
                <div class="">
                    <button @click="storeCommand" class="w-full p-4 py-3 text-white rounded-xl font-medium sm:mt-14 transition duration-200"
                    :style="{background:  !isLoadingAction ? '#323232' : '#f5f5f5', color: !isLoadingAction ? '#fff' : '#949494'}" :disabled="isLoadingAction">
                        <span v-if="!isLoadingAction">Adicionar cliente</span>
                        <span v-else>Carregando...</span>
                    </button>
                </div>
            </div>
        </MyModal>

        <!-- Start select transfer table modal -->
        <MyModal :isOpen="isChangeTableNumberModalOpen" :toggleModal="(v: boolean) => isChangeTableNumberModalOpen = v" :zIndex="80">
            <div class="p-4 flex flex-col gap-4">
                <div class="flex justify-between items-center">
                    <button @click="isChangeTableNumberModalOpen = false" class="transition duration-200 hover:text-primary">
                        <svg viewBox="0 0 24 24" role="presentation" style="width: 1.5rem; height: 1.5rem;"><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" style="fill: currentcolor;"></path></svg>
                    </button>
                    <h3 class="text-xl font-semibold">Transferir mesa</h3>
                </div>
                <div class="flex justify-between items-center bg-gray-100 p-4 rounded-xl">
                    <div class="flex flex-col items-center">
                        <span class="text-xs text-gray-500 uppercase font-bold">DE</span>
                        <button class="bg-zinc-800 text-white font-semibold px-3 py-1 rounded-lg flex items-center gap-2">
                             Mesa {{ selectedTable }}
                        </button>
                    </div>
                    <svg viewBox="0 0 24 24" role="presentation" style="width: 1.5rem; height: 1.5rem;"><path d="M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z" style="fill: currentcolor;"></path></svg>
                    <div class="flex flex-col items-center">
                        <span class="text-xs text-gray-500 uppercase font-bold">PARA</span>
                        <button v-if="selectedTableNumberToTransfer" class="bg-primary text-white font-semibold px-3 py-1 rounded-lg">
                             Mesa {{ selectedTableNumberToTransfer }}
                        </button>
                        <span v-else class="text-sm font-semibold text-gray-400">?</span>
                    </div>
                </div>
                <p class="text-sm text-gray-500">Selecione a mesa de destino:</p>
                <div class="flex flex-wrap gap-2 overflow-auto max-h-60 p-1">
                    <button 
                         v-for="tableNumber in tableCount" 
                         :key="'transfer-'+tableNumber"
                        @click="selectedTableNumberToTransfer = tableNumber" 
                        :class="selectedTableNumberToTransfer == tableNumber ? 'bg-primary text-white':'border'" 
                        class="p-2 px-4 rounded-xl transition duration-200"
                    >
                        <span v-if="tableNumber < 10">0</span>{{ tableNumber }}
                    </button>
                </div>
                <div class="flex gap-4 mt-4">
                    <button @click="isChangeTableNumberModalOpen = false" class="flex-1 p-3 bg-gray-200 rounded-xl font-semibold">Cancelar</button>
                    <button 
                        :disabled="!selectedTableNumberToTransfer || selectedTableNumberToTransfer == selectedTable || isLoadingAction" 
                        @click="updateCommands('transfer', selectedTableNumberToTransfer)" 
                        class="flex-1 p-3 bg-primary text-white rounded-xl font-semibold disabled:opacity-50"
                    >
                        Transferir
                    </button>
                </div>
            </div>
        </MyModal>

        <!-- Use a FAB-like button when table is open to add another customer to it -->
        <button v-if="isTableOpen" @click="openAddCustomerToExistingTable" class="bg-primary fixed right-4 bottom-[20%] p-4 rounded-full z-40 box-shadow text-white">
            <svg viewBox="0 0 24 24" role="presentation" style="width: 1.5rem; height: 1.5rem;"><path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" style="fill: currentcolor;"></path></svg>
        </button>

        <!-- Table tabs modal -->
        <MyModal :isOpen="isTableOpen" :toggleModal="(v: boolean) => isTableOpen = v">
            <div class="p-4 flex flex-col gap-4">
                <div class="flex justify-between items-center border-b pb-4">
                    <button class="transition duration-200 hover:text-primary" @click="isTableOpen = false">
                        <svg viewBox="0 0 24 24" role="presentation" style="width: 1.5rem; height: 1.5rem;"><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" style="fill: currentcolor;"></path></svg>
                    </button>
                    <div class="flex gap-2 items-center">
                        <button class="bg-zinc-800 text-white font-semibold px-4 py-2 rounded-lg flex items-center gap-2">
                            Mesa {{ selectedTable }}
                        </button>
                        <button class="border p-2 px-3 rounded-lg hover:bg-gray-100 transition" @click="isChangeTableNumberModalOpen = true">
                            <svg viewBox="0 0 24 24" role="presentation" style="width: 1.2rem; height: 1.2rem;"><path d="M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z" style="fill: currentcolor;"></path></svg>
                        </button>
                    </div>
                </div>
                <div class="flex flex-col gap-3 py-2">
                    <div v-for="tab in (commands[selectedTable!] ?? [])" :key="tab.id" class="border rounded-xl overflow-hidden">
                        <div class="p-4 flex justify-between items-center hover:bg-gray-50 transition duration-200">
                            <div class="flex items-center gap-4 flex-1">
                                <div class="bg-gray-100 p-2 rounded-full text-gray-500">
                                    <svg viewBox="0 0 24 24" role="presentation" style="width: 1.5rem; height: 1.5rem;"><path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M12,13C14.67,13 20,14.33 20,17V20H4V17C4,14.33 9.33,13 12,13M12,14.9C9.03,14.9 5.9,16.36 5.9,17V18.1H18.1V17C18.1,16.36 14.97,14.9 12,14.9Z" style="fill: currentcolor;"></path></svg>
                                </div>
                                <div>
                                    <h6 class="font-bold text-sm">{{ tab.name || (tab.customer?.name || 'Cliente sem nome') }}</h6>
                                    <p class="text-xs text-gray-400 only-1-lines">{{ tab.description || 'Nenhuma descrição' }}</p>
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <button @click="toggleTabOrders(tab.id)" class="bg-blue-100 p-2 rounded-lg text-blue-600 hover:bg-blue-200 transition" title="Ver histórico">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v20M2 12h20"/></svg>
                                </button>
                                <RouterLink :to="{name:'pos', params: {tab_id: tab.id}}" @click="selectedCommand = tab" class="bg-primary p-2 rounded-lg text-white">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="M7 21h10"/><path d="M12 3v18"/><path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"/></svg>
                                </RouterLink>
                                <button @click="updateCommands('paid', undefined, tab.id)" class="bg-red-500 p-2 rounded-lg text-white" title="Fechar comanda">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>
                                </button>
                            </div>
                        </div>
                        <!-- Orders History -->
                        <div v-if="expandedTabId === tab.id && tabOrdersLoading" class="border-t bg-gray-50 p-4">
                            <p class="text-xs text-gray-400 text-center">Carregando...</p>
                        </div>
                        <div v-else-if="expandedTabId === tab.id" class="border-t bg-gray-50 p-4">
                            <p class="text-xs font-bold text-gray-600 mb-3">Pedidos da comanda:</p>
                            <div v-if="tabOrders[tab.id]?.length" class="flex flex-col gap-2 max-h-48 overflow-y-auto">
                                <div v-for="order in tabOrders[tab.id]" :key="order.id" class="bg-white p-2 rounded text-xs border">
                                    <div class="flex justify-between items-start mb-1">
                                        <span class="font-bold text-gray-700">Pedido #{{ order.id }}</span>
                                        <span class="text-[10px] px-2 py-0.5 rounded" :style="{background: getOrderStatusColor(order.status), color: 'white'}">
                                            {{ getOrderStatusLabel(order.status) }}
                                        </span>
                                    </div>
                                    <p class="text-gray-600">{{ order.items?.length || 0 }} item(ns) - {{ order.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</p>
                                </div>
                            </div>
                            <p v-else class="text-xs text-gray-400 text-center py-2">Nenhum pedido</p>
                        </div>
                    </div>
                </div>
                <div class="mt-4 border-t pt-4 flex flex-col gap-3">
                    <button @click="startAccountSplit" class="w-full p-4 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition">
                        Dividir Conta
                    </button>
                    <button @click="updateCommands('paid')" class="w-full p-4 bg-zinc-800 text-white rounded-xl font-bold hover:bg-zinc-700 transition disabled:opacity-50" :disabled="isLoadingAction">
                        <span v-if="!isLoadingAction">Fechar todas</span>
                        <span v-else>Processando...</span>
                    </button>
                </div>
            </div>
        </MyModal>

        <!-- Account Split Modal -->
        <MyModal :isOpen="isAccountSplitModalOpen" :toggleModal="(v: boolean) => isAccountSplitModalOpen = v">
            <div class="p-6 flex flex-col gap-4">
                <div class="flex justify-between items-center border-b pb-4">
                    <h2 class="text-lg font-bold">Dividir Conta</h2>
                    <button @click="isAccountSplitModalOpen = false" class="text-gray-400 hover:text-gray-600">
                        <svg viewBox="0 0 24 24" role="presentation" style="width: 1.5rem; height: 1.5rem;"><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" fill="currentColor"></path></svg>
                    </button>
                </div>

                <div class="flex flex-col gap-4">
                    <div class="bg-gray-50 rounded-2xl p-4">
                        <p class="text-xs text-gray-500 uppercase font-bold mb-2">Número de Pessoas</p>
                        <div class="flex items-center justify-between">
                            <button @click="splitNumberOfPeople > 2 ? splitNumberOfPeople-- : null" class="p-2 hover:bg-gray-200 rounded-lg transition">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg>
                            </button>
                            <input
                                v-model.number="splitNumberOfPeople"
                                type="number"
                                min="2"
                                class="text-2xl font-bold text-center w-16 bg-transparent border-b-2 border-primary focus:outline-none"
                            />
                            <button @click="splitNumberOfPeople++" class="p-2 hover:bg-gray-200 rounded-lg transition">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>
                            </button>
                        </div>
                    </div>

                    <div class="bg-blue-50 rounded-2xl p-4 border border-blue-100">
                        <p class="text-sm text-blue-800 font-bold">
                            Total: {{ selectedTabTotalAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                        </p>
                        <p class="text-sm text-blue-700 mt-1">
                            Por pessoa: {{ (selectedTabTotalAmount / splitNumberOfPeople).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                        </p>
                    </div>

                    <button
                        @click="createAccountSplit"
                        :disabled="isLoadingAction || splitNumberOfPeople < 2"
                        class="w-full p-4 bg-primary text-white rounded-2xl font-bold hover:bg-opacity-90 transition disabled:opacity-50"
                    >
                        {{ isLoadingAction ? 'Processando...' : 'Criar Divisão' }}
                    </button>
                </div>
            </div>
        </MyModal>

        <!-- Payment Progress Modal (shown after split is created) -->
        <MyModal :isOpen="isPaymentProgressModalOpen" :toggleModal="(v: boolean) => { if (!v) { isPaymentProgressModalOpen = false; isAccountSplitModalOpen = true; } else { isPaymentProgressModalOpen = v } }">
            <div class="p-6 flex flex-col gap-4">
                <h2 class="text-lg font-bold">Cobrança - Divisão de Conta</h2>

                <div class="space-y-3">
                    <div v-for="person in splitPaymentProgress" :key="person.index" class="flex items-center justify-between p-4 border rounded-2xl" :class="person.paid ? 'bg-green-50 border-green-200' : 'bg-gray-50'">
                        <div class="flex items-center gap-3">
                            <div class="flex items-center justify-center w-8 h-8 rounded-full" :class="person.paid ? 'bg-green-500 text-white' : 'bg-gray-300 text-gray-600'" :style="person.paid ? {} : {}">
                                <span v-if="person.paid" class="font-bold text-sm">✓</span>
                                <span v-else class="font-bold text-sm">{{ person.index + 1 }}</span>
                            </div>
                            <div>
                                <p class="font-bold text-gray-800">Pessoa {{ person.index + 1 }}</p>
                                <p class="text-xs text-gray-500">{{ person.amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</p>
                            </div>
                        </div>
                        <button
                            v-if="!person.paid"
                            @click="markPersonAsPaid(person.index)"
                            :disabled="isLoadingAction"
                            class="px-4 py-2 bg-primary text-white rounded-lg font-bold text-sm hover:bg-opacity-90 transition disabled:opacity-50"
                        >
                            Pago
                        </button>
                        <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-green-500">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                            <path d="M22 4 12 14.01l-3-3"/>
                        </svg>
                    </div>
                </div>

                <div class="bg-blue-50 rounded-2xl p-4 border border-blue-100">
                    <p class="text-sm font-bold text-blue-900">
                        {{ paidCount }}/{{ splitNumberOfPeople }} pessoas pagaram
                    </p>
                    <div class="w-full bg-blue-200 rounded-full h-2 mt-2">
                        <div class="bg-blue-600 h-2 rounded-full" :style="{ width: ((paidCount / splitNumberOfPeople) * 100) + '%' }"></div>
                    </div>
                </div>
            </div>
        </MyModal>
    </div>
</template>

<script lang="ts" setup>
import MyModal from '@/components/modal/MyModal.vue';
import { computed, ref } from 'vue'
import { commands, selectedCommand, me, organizationSettings } from '@/global/state/GlobalState';
import axiosClient from '@/api/axios';
import { useToast } from 'vue-toastification';

const isTableOpen = ref<boolean>(false)
const selectedTable = ref<number | null>(null)
const isAddCustomerModalOpen = ref<boolean>(false)
const isChangeTableNumberModalOpen = ref<boolean>(false)
const selectedTableNumberToTransfer = ref<number | undefined>(undefined)
const expandedTabId = ref<number | null>(null)
const tabOrders = ref<Record<number, any[]>>({})
const tabOrdersLoading = ref<boolean>(false)
const isAccountSplitModalOpen = ref<boolean>(false)
const isPaymentProgressModalOpen = ref<boolean>(false)
const splitNumberOfPeople = ref<number>(2)
const currentAccountSplit = ref<any>(null)
const splitPaymentProgress = ref<any[]>([])

const commandForm = ref<any>({
    number: null,
    name: '',
    description: ''
})
const isLoadingAction = ref<boolean>(false)

const toast = useToast()

const tableCount = computed(() => {
    let startingTable = me.value.metadata?.startingTable ?? 1
    let endTable = me.value.metadata?.endTable ?? (organizationSettings.value.quantityOfTables || 0)

    let tablesArr = []
    for (let i = startingTable; i <= endTable; i++) {
        tablesArr.push(i)
    }

    return tablesArr
})

const selectedTabTotalAmount = computed(() => {
    if (!selectedTable.value) return 0
    const tabs = commands.value[selectedTable.value!] || []
    let total = 0
    tabs.forEach((tab: any) => {
        total += tab.orderTotal || 0
    })
    return total
})

const paidCount = computed(() => {
    return splitPaymentProgress.value.filter((p: any) => p.paid).length
})

function onClickCommand(tableNumber: number){
    selectedTable.value = tableNumber
    if (commands.value[tableNumber] && commands.value[tableNumber].length > 0) {
        isTableOpen.value = true
    } else {
        openAddCustomerModal(tableNumber)
    }
}

function openAddCustomerModal(tableNumber: number) {
    commandForm.value.number = tableNumber
    commandForm.value.name = ''
    commandForm.value.description = ''
    isAddCustomerModalOpen.value = true
}

function openAddCustomerToExistingTable() {
    if (selectedTable.value) {
        openAddCustomerModal(selectedTable.value)
    }
}

async function storeCommand(){
    if (!commandForm.value.name && !commandForm.value.customerId) {
        // New API needs name or customerId
        // In this app, we mostly use descriptive names for waitlisting/commands
    }

    isLoadingAction.value = true
    axiosClient.post('/tabs', commandForm.value)
    .then((res: any) => {
        const tab = res.data.data || res.data
        if(!commands.value[tab.number]) commands.value[tab.number] = []
        commands.value[tab.number].push(tab)
        
        isLoadingAction.value = false
        isAddCustomerModalOpen.value = false
        toast.success("Cliente adicionado com sucesso")
    })
    .catch((err: any) => {
        isLoadingAction.value = false
        const message = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || "Erro ao adicionar cliente"
        toast.error(message)
    })
}

async function updateCommands(action: 'transfer' | 'paid', targetNumber?: number, tabId?: number){
    isLoadingAction.value = true

    const tabsToUpdate = tabId
        ? (commands.value[selectedTable.value!] || []).filter((c: any) => c.id == tabId)
        : (commands.value[selectedTable.value!] || [])

    if (tabsToUpdate.length === 0) {
        isLoadingAction.value = false
        return
    }

    try {
        for (const tab of tabsToUpdate) {
            const payload: any = {}
            if (action === 'transfer' && targetNumber) {
                payload.number = targetNumber
            } else if (action === 'paid') {
                payload.closedAt = new Date().toISOString()
            }

            await axiosClient.patch(`/tabs/${tab.id}`, payload)
        }

        // Refresh commands globally
        const res = await axiosClient.get('/tabs')
        let _commands: any = {}
        const tabs = res.data.data || res.data;
        if (Array.isArray(tabs)) {
            tabs.forEach((tab: any) => {
                const number = tab.number;
                if(!_commands[number]) _commands[number] = [];
                _commands[number].push(tab);
            })
        }
        commands.value = _commands

        toast.success(action === 'transfer' ? "Transferido com sucesso" : "Mesa fechada com sucesso")
        isTableOpen.value = false
        isChangeTableNumberModalOpen.value = false
        selectedTableNumberToTransfer.value = undefined
    } catch (err: any) {
        const message = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || "Erro ao processar ação"
        toast.error(message)
    } finally {
        isLoadingAction.value = false
    }
}

async function toggleTabOrders(tabId: number) {
    if (expandedTabId.value === tabId) {
        expandedTabId.value = null
    } else {
        expandedTabId.value = tabId
        if (!tabOrders.value[tabId]) {
            await loadTabOrders(tabId)
        }
    }
}

async function loadTabOrders(tabId: number) {
    try {
        tabOrdersLoading.value = true
        const res = await axiosClient.get(`/tabs/${tabId}`)
        const tab = res.data.data || res.data
        tabOrders.value[tabId] = tab.orders || []
    } catch (err: any) {
        toast.error("Erro ao carregar pedidos da comanda")
    } finally {
        tabOrdersLoading.value = false
    }
}

function getOrderStatusColor(status: string): string {
    const colors: Record<string, string> = {
        'PENDING': '#918373',
        'PREPARING': '#FF9B3D',
        'PREPARED': '#59A6F8',
        'DELIVERED': '#00c9a7',
        'CANCELED': '#F83535',
        'COMPLETED': '#00c9a7',
    }
    return colors[status] || '#999'
}

function getOrderStatusLabel(status: string): string {
    const labels: Record<string, string> = {
        'PENDING': 'pendente',
        'PREPARING': 'preparando',
        'PREPARED': 'preparado',
        'DELIVERED': 'entregue',
        'CANCELED': 'cancelado',
        'COMPLETED': 'concluído',
    }
    return labels[status] || status
}

function startAccountSplit() {
    if (!selectedTable.value) return
    const selectedTabObj = (commands.value[selectedTable.value!] || [])[0]
    if (!selectedTabObj) return

    isAccountSplitModalOpen.value = true
    splitNumberOfPeople.value = 2
}

async function createAccountSplit() {
    if (!selectedTable.value) return
    const selectedTabObj = (commands.value[selectedTable.value!] || [])[0]
    if (!selectedTabObj || splitNumberOfPeople.value < 2) return

    try {
        isLoadingAction.value = true
        const res = await axiosClient.post(`/tabs/${selectedTabObj.id}/split`, {
            numberOfPeople: splitNumberOfPeople.value
        })
        currentAccountSplit.value = res.data.data || res.data

        // Initialize payment progress array
        splitPaymentProgress.value = Array.from({ length: splitNumberOfPeople.value }, (_, index) => ({
            index,
            paid: false,
            amount: currentAccountSplit.value.amountPerPerson
        }))

        isAccountSplitModalOpen.value = false
        isPaymentProgressModalOpen.value = true
        toast.success('Divisão criada! Registre os pagamentos.')
    } catch (err: any) {
        const message = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || "Erro ao criar divisão"
        toast.error(message)
    } finally {
        isLoadingAction.value = false
    }
}

async function markPersonAsPaid(personIndex: number) {
    if (!currentAccountSplit.value) return

    try {
        isLoadingAction.value = true
        const res = await axiosClient.patch(`/tabs/split/${currentAccountSplit.value.id}/pay`, {
            personIndex,
            paymentMethod: 'cash' // Default payment method - can be customized
        })

        // Update local state
        splitPaymentProgress.value[personIndex].paid = true

        const result = res.data.data || res.data
        if (result.isComplete) {
            toast.success('Todos pagaram! Conta finalizada.')
            setTimeout(() => {
                isPaymentProgressModalOpen.value = false
                isAccountSplitModalOpen.value = false
                isTableOpen.value = false
                // Refresh commands
                updateCommands('paid')
            }, 1000)
        } else {
            toast.success(`Pessoa ${personIndex + 1} pagou. ${result.paidCount}/${result.totalPeople}`)
        }
    } catch (err: any) {
        const message = err.response?.data?.errors?.[0]?.message || "Erro ao registrar pagamento"
        toast.error(message)
    } finally {
        isLoadingAction.value = false
    }
}
</script>

<style lang="scss" scoped>
.box-shadow {
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
}
.only-1-lines {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>